import { useTranslation } from 'react-i18next';
import { type FC, useMemo, useRef } from 'react';
import MultiSelect from '__components/Inputs/MultiSelect';
import ClearSelectButton from '__components/Inputs/Select/ClearButton';
import ApplySelectButton from '__components/Inputs/Select/ApplyButton';
import { ALLOWED_FILE_EXTENSIONS } from '__components/FilePicker/constants';

export const FilesOptions: FC<{
  updateField: (field: string, value: any) => void;
  formData: { meta?: { allowed?: string[] } };
}> = ({ updateField, formData }) => {
  const { t } = useTranslation();

  const handleChangeAllowed = (value: { value: string }[]) => {
    updateField('meta', {
      ...formData?.meta,
      allowed: value.map(({ value }) => value),
    });
  };

  const value = useMemo(
    () =>
      (formData.meta?.allowed || []).map((ext) => ({
        value: ext,
        label: ext,
      })),
    [formData.meta?.allowed]
  );

  const options = useMemo(
    () =>
      ALLOWED_FILE_EXTENSIONS.map((ext) => ({
        value: ext,
        label: ext,
      })),
    []
  );

  const anchorRef = useRef<HTMLDivElement>(null);

  const onMenuOpen = () => {
    setTimeout(() => {
      if (anchorRef.current) {
        anchorRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 0);
  };

  return (
    <div>
      <MultiSelect
        label={t('Allowed Extensions')}
        placeholder={'Leave Blank for All'}
        value={value}
        options={options}
        onChange={handleChangeAllowed}
        data-qa="allowed-extensions"
        menuLeftButton={<ClearSelectButton />}
        menuRightButton={<ApplySelectButton />}
        onMenuOpen={onMenuOpen}
      />
      <div ref={anchorRef} />
    </div>
  );
};
